/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconLander = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M12 16.5V21M5.25 23.25a2.25 2.25 0 1 0-4.5 0h4.5zM14.25 23.25a2.25 2.25 0 1 0-4.5 0h4.5zM23.25 23.25a2.25 2.25 0 1 0-4.5 0h4.5zM18 18l-1.061-1.061a1.499 1.499 0 0 0-1.06-.439H8.121c-.398 0-.779.158-1.06.439L6 18" />
        <path d="M21 21v-3.879c0-.398-.158-.779-.439-1.06l-2.122-2.122a1.499 1.499 0 0 0-1.06-.439H6.618a1.5 1.5 0 0 0-1.057.436l-2.118 2.1A1.502 1.502 0 0 0 3 17.1V21" />
        <path d="M7.5 10.5h9v3h-9v-3zM7.5 10.5A4.7 4.7 0 0 1 6 7.1C6 4.132 8.686.75 12 .75s6 3.382 6 6.35a4.7 4.7 0 0 1-1.5 3.4" />
        <path d="M13.5 10.5h-3V7.483c0-.819.664-1.483 1.483-1.483h.034c.819 0 1.483.664 1.483 1.483V10.5zM10.5 10.5v3M13.5 10.5v3" />
      </g>
    </svg>
  ),
);
